import { render, staticRenderFns } from "./LocationUpdate.vue?vue&type=template&id=635e6379"
import script from "./LocationUpdate.vue?vue&type=script&lang=ts"
export * from "./LocationUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports